import React from 'react'
import { ArrowRight } from '@next-nx/shared-ui/icons'
import { Button, WImage } from '@next-nx/shared-ui/atoms'
import styles from './NoleggioStepCarouselAnimation.module.sass'


interface Props {
  title1: string
  image1: string
  title2: string
  image2: string
  className?: string
}

const NoleggioStepCarouselAnimation = (props: Props) => {

  const {
    title1 = '',
    image1 = '',
    title2 = '',
    image2 = '',
    className = '',
  } = props

  return (
    <div className={`${styles.root} ${className}`}>
      <div className={styles.image1Box}>
        <WImage 
          src={image1}
          alt={title1}
          title={title1}
          maxWidth={456}
          maxHeight={150}
          layout="intrinsic"
        />
      </div>
      <div className={styles.image2Box}>
        <WImage 
          src={image2}
          alt={title2}
          title={title2}
          maxWidth={456}
          maxHeight={150}
          layout="intrinsic"
        />
      </div>
      <div className={styles.arrowBox}>
        <span className={styles.arrow}><ArrowRight /></span>
      </div>
    </div>
  )
}

export default NoleggioStepCarouselAnimation
